import { SALES_CHANNEL_COPY } from '#app/routes/mocra+/_form+/components/sales-channels/constants.ts'
import { RECALL_SALES_CHANNEL_OPTIONS } from '#app/routes/mocra+/_form+/intake-options.ts'

export type SalesChannelTypeValue =
	(typeof RECALL_SALES_CHANNEL_OPTIONS)[number]['value']

export type SalesChannelDraft = {
	type: SalesChannelTypeValue
	name: string
}

export function createSalesChannelDraft(
	overrides: Partial<SalesChannelDraft> = {},
): SalesChannelDraft {
	return {
		type: RECALL_SALES_CHANNEL_OPTIONS[0]?.value ?? 'direct_to_consumer',
		name: '',
		...overrides,
	}
}

export function sanitizeSalesChannelDraft(
	draft: SalesChannelDraft,
): SalesChannelDraft {
	const type = isSalesChannelTypeValue(draft.type)
		? draft.type
		: (RECALL_SALES_CHANNEL_OPTIONS[0]?.value ?? 'direct_to_consumer')
	return {
		type,
		name: draft.name.trim(),
	}
}

export function collectSalesChannelErrors(draft: SalesChannelDraft): string[] {
	const sanitized = sanitizeSalesChannelDraft(draft)
	const errors: string[] = []
	if (sanitized.name.length === 0) {
		errors.push('Name the channel or partner.')
	}
	return errors
}

export function salesChannelCardTitle(draft: SalesChannelDraft): string {
	const sanitized = sanitizeSalesChannelDraft(draft)
	const label = resolveSalesChannelLabel(sanitized.type)
	return label
}

export function formatSalesChannelSummary(draft: SalesChannelDraft): string {
	const sanitized = sanitizeSalesChannelDraft(draft)
	return sanitized.name || SALES_CHANNEL_COPY.summary.nameMissing
}

export function resolveSalesChannelLabel(value: SalesChannelTypeValue): string {
	return (
		RECALL_SALES_CHANNEL_OPTIONS.find((option) => option.value === value)
			?.label ?? value
	)
}

export function isSalesChannelTypeValue(
	value: unknown,
): value is SalesChannelTypeValue {
	return RECALL_SALES_CHANNEL_OPTIONS.some((option) => option.value === value)
}
